module.exports = __webpack_public_path__ + "img/banner.87f1ca3d.jpg";